/**
 * A component that displays a dropdown option.
 * - Calls callback prop, and creates CLOSE_DROPOWN action, when clicked
 * - Displays label and icon from props
 *
 * @module components/Dropdown/Option
 */

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import CheckOptionIcon from '../../../../static/icons/check.svg';
import Avatar from '../../../components/Avatar';
import Icon from '../../../components/Icon';
import { AriaRoles } from '../../../constants/AccessibilityConstants';

import './DropdownOption.scss';

const { string, func, any, array, bool, oneOfType, node } = PropTypes;

export default class extends React.Component {
  static propTypes = {
    callback: func,
    qaTag: string,
    // label can be a string or a FormattedMessage
    label: oneOfType([string, node]).isRequired,
    menuType: any,
    disabled: bool,
    closeDropdown: func,
    extrasStyles: array,
    showAvatar: bool,
    listenerImgUrl: string,
    isSelected: bool,
    isSelectable: bool,
    updateSearchOverlay: func,
    pathname: string,
    externalUrl: string,
  };

  onClick = event => {
    event.preventDefault();
    const { callback } = this.props;
    if (callback) {
      callback();
    }
    if (this.props.closeDropdown) {
      this.props.closeDropdown();
    }
    if (this.props.updateSearchOverlay) {
      this.props.updateSearchOverlay();
    }
  };

  getSelectedRegion = () => {
    if (this.props.isSelectable) {
      const selectedCheck = this.props.isSelected ? (
        <Icon glyph={CheckOptionIcon} className='selected_check' />
      ) : null;
      const classes = classNames('DropdownOption__selectedArea', {
        'DropdownOption--selected': this.props.isSelected,
      });
      return <div className={classes}>{selectedCheck}</div>;
    }
    return null;
  };

  render() {
    const avatar = this.props.showAvatar ? (
      <Avatar inDropdown={true} listenerImgUrl={this.props.listenerImgUrl} />
    ) : null;
    const selectedArea = this.getSelectedRegion();
    const { label } = this.props;
    let className = 'DropdownOption';
    if (this.props.disabled) {
      className += ' DropdownOption--disabled';
    } else {
      className += ' DropdownOption--enabled';
    }
    if (this.props.isSelected) {
      className += ' DropdownOption--selected';
    }
    if (this.props.extrasStyles && this.props.extrasStyles.length) {
      className += ' ' + this.props.extrasStyles.join(' ');
    }
    if (!this.props.pathname && !this.props.externalUrl) {
      return (
        <li className={className} data-qa={this.props.qaTag} role={AriaRoles.PRESENTATION}>
          <button
            type='button'
            className='DropdownOption__item'
            onClick={this.onClick}
            role={AriaRoles.MENUITEM}
          >
            {selectedArea}
            {avatar}
            {label}
          </button>
        </li>
      );
    }
    return (
      <li className={className} data-qa={this.props.qaTag} role={AriaRoles.PRESENTATION}>
        <a
          className='DropdownOption__item'
          href={this.props.pathname || this.props.externalUrl || '#'}
          onClick={this.onClick}
          role={AriaRoles.MENUITEM}
        >
          {selectedArea}
          {avatar}
          {label}
        </a>
      </li>
    );
  }
}
